import { Value } from '../formula'

/**
 * Em-dash separator placed between a Spread row's `min` and `max` values.
 * Built from the Formula {@link Value} primitive so typography (h5/600,
 * baseline alignment) matches the numbers around it. Renders with
 * `text.secondary` so it visually recedes between the two bounds.
 */
export function Separator() {
  return <Value color='inherit'>-</Value>
}
